import { render, staticRenderFns } from "./SortCategoriesModal.vue?vue&type=template&id=61a27a49"
import script from "./SortCategoriesModal.vue?vue&type=script&lang=js"
export * from "./SortCategoriesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports